<template>
  <div
    class="tab-bar fixed fb fb-main-between fb-cross-center bg-FFFFFF width-full"
  >
    <a
      class="block item-flex-1"
      v-for="(item, index) in tabBarList"
      :key="index"
      @click="() => loadPage(item)"
    >
      <div class="text-center c-171A1D-40">
        <div
          ><i
            class="iconfont font-48"
            :class="{ curPage: curPage === item.name }"
            v-html="curPage === item.name ? item.checkIcon : item.defaultIcon"
          ></i
        ></div>
        <p
          :class="{
            'c-006AFE': curPage === item.name
          }"
          >{{ item.buttonName }}</p
        >
      </div>
    </a>
  </div>
</template>

<script>
import { mcAlert } from '@/utils/mcSdkUtils'
// import scrollCache from '@/mixin/scrollCache'
export default {
  // mixins: [scrollCache],
  props: {
    currentPage: {
      type: String,
      default: 'VehicleRecords'
    },
    tabBarList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      curPage: this.currentPage
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadPage(routeConfig) {
      if (
        !(this.$store.state.parklotInfo || {}).bound &&
        ['VehicleSetting', 'VehicleLift'].includes(routeConfig.name)
      ) {
        mcAlert({
          title: '提示',
          msg: '当前校区下未绑定停车场，无法使用当前功能。',
          buttonName: '我知道了'
        })
        return false
      }
      this.curPage = routeConfig.name
      this.$emit('loadPage', routeConfig.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-bar {
  bottom: 0;
  height: 62px !important;
  box-shadow: 0px -0.5px 0px 0px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(20px);
}
.curPage {
  background-image: -webkit-linear-gradient(top, #00b7ff, #006afe);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
